import { CredentialType as CredentialType_ } from '#/constants/pectra/credential-type';
import matchSwitch from 'match-switch';
import { Badge } from '../ui/badge';

interface Props {
  credentialType: CredentialType_;
}

export function CredentialTypeFlag({ credentialType }: Props) {
  return (
    <>
      {credentialType == CredentialType_.TYPE1 ? (
        <Badge variant="destructive">Legacy</Badge>
      ) : (
        ''
      )}
    </>
  );
}

export function CredentialType({ credentialType }: Props) {
  return matchSwitch(credentialType, {
    [CredentialType_.TYPE1]: '0x01',
    [CredentialType_.TYPE2]: '0x02',
  });
}

export function CredentialTypeComplex({ credentialType }: Props) {
  return matchSwitch(credentialType, {
    [CredentialType_.TYPE1]: 'Legacy (0x01)',
    [CredentialType_.TYPE2]: 'Full Compounding (0x02)',
  });
}
